<template>
  <v-dialog v-model="dialog" max-width="40rem">
    <div class="d-flex align-center justify-center">
      <v-img
        :src="require('@/assets/home/sunburst.png')"
        class="absolute"
        max-width="80%"
      />

      <v-img
        :src="require('@/assets/home/wheel-header-part.png')"
        max-width="90%"
        contain
      >
        <div class="d-flex fill-height align-start justify-center pt-4">
          <v-img
            :src="require('@/assets/home/bonus-title.png')"
            max-width="70%"
            contain
          />
        </div>
      </v-img>
    </div>

    <v-card
      class="card pa-6 pa-md-12 rounded-xl gradient-top-down mt-n4"
      color="neutral3"
    >
      <v-btn color="white" absolute right icon @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div
        class="text-center text-h6 text-md-h5 font-weight-black mb-4 primary--text"
      >
        Bônus Disponível!
      </div>

      <div class="text-body-1 text-center mb-8">
        Seu <strong>bônus diário</strong> foi liberado. Com apenas um giro, você
        pode ganhar prêmios instantâneos incríveis.
      </div>

      <v-row>
        <v-col cols="12" md="6" order="2" order-md="1">
          <v-btn
            class="btn white--text"
            color="secondary"
            rounded
            large
            block
            @click="close()"
          >
            Talvez depois
          </v-btn>
        </v-col>

        <v-col cols="12" md="6" order="1" order-md="2">
          <v-btn
            class="btn"
            color="primary"
            rounded
            large
            block
            @click="
              submit();
              close();
            "
          >
            Quero meu bônus

            <v-icon right> fas fa-chevron-right </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BonusCall",

  data() {
    return {
      dialog: false,
      bonusSound: null,
    };
  },

  mounted() {
    this.bonusSound = new Audio(require("@/assets/sounds/bonus.mp3"));
  },

  methods: {
    submit() {
      this.$emit("submit");
    },

    close() {
      this.dialog = false;
      this.$emit("cancel");
    },

    open() {
      this.dialog = true;

      if (!this.bonusSound)
        this.bonusSound = new Audio(require("@/assets/sounds/bonus.mp3"));

      this.bonusSound.volume = 0;

      this.bonusSound
        .play()
        .then(() => {
          this.bonusSound.volume = 1;
        })
        .catch(() => {
          /* ignore */
        });
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
